import styled from "styled-components";

import {
  alignItemsCenter,
  alpha,
  circle,
  flexCenter,
  flexColumn,
  flexSpBetween,
  rem,
} from "@styles/Utilities.styled";


export const StyledConsultation = styled.section`
  margin-top: 2rem;
  margin-bottom: 8rem;

  .header {
    ${flexSpBetween}
  }

  .new-consultation-wrapper {
    ${flexColumn}
    justify-content: center;
    text-align: center;

    .img-wrapper {
      max-width: ${rem(500)};
      margin-inline: auto;
      /* outline: 1px solid rebeccapurple; */

      // Special case
      @media screen and (min-height: 64em) {
        max-width: ${rem(700)};
      }
    }

    .text-content {
      ${alignItemsCenter}
      gap: 2rem;

      p {
        font-size: ${rem(15)};
        line-height: 1;
        /* outline: 1px solid red; */
      }

      .alt-btn {
        color: inherit;
        text-decoration: underline;
        font-size: ${rem(15)};

        span {
          font-weight: 600;
        }
      }
    }

    .instructions-header {
      margin-top: 4rem;
      text-align: left;

      h2 {
        font-weight: 500;
        font-size: ${rem(20)};
      }
    }

    .consultation-cards {
      display: flex;
      flex-flow: row wrap;
      /* display: grid;
      grid-template-columns: repeat(4, 1fr); */
      /* justify-content: center; */
      gap: 2rem 1.5rem;
      margin-top: 3rem;

      &-item {
        min-width: ${rem(250)};
        padding: 1.5rem 1rem 1.5rem;
        border: 1px solid var(--clr-gray-175);
        border-radius: var(--border-radius-3);
        max-width: ${rem(250)};
        transition: border-color 0.1s;

        &.disabled {
          filter: grayscale(1);
          opacity: 0.5;
          cursor: unset;
        }

        &:hover:not(.disabled) {
          border-color: var(--clr-primary-400);
        }

        .icon-wrapper {
          --icon-size: 2rem;

          ${flexCenter}
          ${circle("calc(var(--icon-size) * 1.75)")}
          margin-inline: auto;

          &.yellow {
            color: var(--clr-yellow);
            background-color: ${alpha("var(--clr-yellow)", 0.1)};
          }
          &.purple {
            color: var(--clr-primary-400);
            background-color: var(--clr-primary-100);
          }
          &.blue {
            color: var(--brown-10);
            background-color: var(--brown-3);
          }
          &.green {
            color: var(--green-10);
            background-color: var(--green-3);
          }
          &.pink {
            color: var(--pink-10);
            background-color: var(--pink-3);
          }
        }

        p {
          line-height: 1.2;

          &:nth-child(2) {
            margin-top: 2.5rem;
            font-size: ${rem(17)};
            font-weight: 500;
          }

          &:last-child {
            font-size: ${rem(13)};
            font-weight: 300;
            margin-top: 0.75rem;
          }
        }

        &:nth-child(3),
        &:nth-child(4) {
          svg {
            font-size: 1.8rem;
          }
        }
      }
    }
  }
`;
